<script>
	import request from './request.vue';
	import { format } from "date-fns";
	import Company from'./company.model.vue'

	let logSchema = [
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome",
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "email",
			displayName: "Email",
			kind: "text",
			validation: "",
			placeholder: "Digite o email",
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "register",
			displayName: "Matrícula",
			kind: "text",
			validation: "",
			placeholder: "",
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		// 
		// {
		// 	name: "role",
		// 	displayName: "Tipo",
		// 	kind: "text",
		// 	validation: "",
		// 	placeholder: "",
		// 	notInFilters: true,
		// 	search: {
		// 		show: true,
		// 		endWildcard: true,
		// 		startWildcard: true,
		// 	},
		// },
		{
			name: "lastLogin",
			displayName: "Último acesso",
			kind: "text", //"date",
			validation: "",
			placeholder: "DD/MM/AAAA",
			mask: "##/##/####",
			readOnly: true,
			formatter: value => {
				if (!value) return "Nunca acessou o novo portal."
				return value; // format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm");
			},
			creationHidden: true,
			defaultSort: true,
			search: {
				show: true,
			},
		},
		{
			name: "timestamp",
			displayName: "Data",
			kind: "text",
			validation: "",
			placeholder: "DD/MM/AAAA",
			readOnly: true,
			//formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			defaultSort: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		// 
		// {
		// 	name: "ipAddress",
		// 	displayName: "IP",
		// 	kind: "text",
		// 	validation: "",
		// 	placeholder: "",
		// 	readOnly: true,
		// 	creationHidden: true,
		// 	defaultSort: true,
		// 	notInFilters: true,
		// 	search: {
		// 		show: true,
		// 	},
		// },
		// {
		// 	name: "companyName",
		// 	displayName: "Empresa",
		// 	kind: "select",
		// 	validation: "",
		// 	placeholder: "",
		// 	readOnly: true,
		// 	formatter: value => value ? value : "Sem empresa",
		// 	options: [],
		// 	notInFilters: true,
		// 	search: {
		// 		show: true,
		// 	}
		// },
		{
			name: "platform",
			displayName: "Plataforma",
			kind: "select",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => value ? value : "WEB",
			options: [
				{
					name: "WEB",
					value: "WEB",
				},
				{
					name: "APP",
					value: "APP",
				}
			],
			search: {
				show: true,
			}
		},
		{
			name: "defaultPassword",
			displayName: "Senha",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		{
			name: "phone",
			displayName: "Telefone",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => value ? value : "Sem telefone",
			notInFilters: true,
			search: {
				show: true,
			},
		},
		{
			name: "dateStart",
			displayName: "Data inicial",
			kind: "date",
			validation: "",
			mask: "##/##/####",
			defaultSort: true,
			readOnly: true,
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInResults: true,
			search: {
				show: true,
			},
		},
		{
			name: "dateEnd",
			displayName: "Data final",
			kind: "date",
			validation: "",
			defaultSort: true,
			readOnly: true,
			mask: "##/##/####",
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			notInResults: true,
			search: {
				show: true,
			},
		},
	];


	export default {
		search: async function(parameters) {
			if (parameters.dateStart) parameters.dateStart = parameters.dateStart.split("/").reverse().join("-");
			if (parameters.dateEnd) parameters.dateEnd = parameters.dateEnd.split("/").reverse().join("-");
			if (parameters.lastLogin) parameters.lastLogin = parameters.lastLogin.split("/").reverse().join("-");

			parameters.orderBy = "timestamp";
			parameters.orderDirection = "desc";

			console.log(parameters);
			const response = await request.send("logs", "search", parameters, true);
			return response;
		},
		getSchema: function() {
			logSchema = logSchema.filter(function( obj ) {
					return obj.displayName !== 'Empresa';
			});
				Company.getAll()
				.then((companys) => {
					logSchema.push({
						name: "companyId",
						displayName: "Empresa",
						kind: "select",
						validation: "",
						placeholder: "",
						readOnly: true,
						formatter: value => value ? value : "Sem empresa",
						options: companys.map(company => ({
							name: company.name,
							value: company.id,
						})),
						notInResults: true,
						search: {
							show: true,
						}
					})
				})
				.catch((err) => console.log(err));

			return logSchema;
		},
	}
</script>
